<script lang="ts">
	import PageHeader from '$lib/components/page-header.svelte';
	import Posts from '$lib/components/posts.svelte';
	import type { PageData } from './$types';

	export let data: PageData;
	export const { posts } = data;
</script>

<svelte:head>
	<title>Posts</title>
</svelte:head>

<section>
	<PageHeader>Posts</PageHeader>
	<Posts {posts} />
</section>
